<template>
  <!-- <chat :msg="msg" @sendMsg="sendMsg" @sendReplyMsg="sendReplyMsg"/> -->
  <b-row>
    <b-col lg="9" md="12" xs="12">
      <!-- <clients :obj="form" @openclient="openclient" :showComp="true" /> -->

      <!-- нові номери клієнти -->
      <clientNumbers
        :obj="form"
        @openclient="openclient"
        @updateCard="updateCard"
      />
      <!-- нові номери клієнти -->
    </b-col>
  </b-row>
</template>

<script>
import clients from "../../../formright/clientnumber.vue";
import clientNumbers from "../../../formright/clientnumberNew";
export default {
  props: ["obj"],
  components: {
    clients,
    clientNumbers,
  },
  data() {
    return {
      form: {},
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.form = this.obj;
    },
    openclient(e) {
      this.$emit("openclient", e);
    },
  },
};
</script>
